module.exports = __webpack_public_path__ + "media/newsletter_page/img2-324ad49e.png";